import React from 'react';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';

const NetworkFailRejection = ({ message, onRetry }) => (
  <EmptyState
    headline={COPY.REJECT_NETWORK_HEADLINE}
    subtitle={message || COPY.REJECT_NETWORK_SUBTITLE}
    ctaLabel={COPY.RETRY_CTA}
    onCta={onRetry}
  />
);

export default NetworkFailRejection;
